<!--
 * @Author: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @Date: 2023-05-18 11:40:07
 * @LastEditors: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @LastEditTime: 2023-05-18 11:52:58
 * @FilePath: \合联\oms\src\view\analysis\smsList\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <cTable :fields="fields" :header="header" :methods="methods" :modals="modals" :config="config" :footer="footer"
    ref="table">
  </cTable>
</template>

<script>
import cTable from '@/base/common/index';
import { apis } from '@/api/analysis/smsList.js'
export default {
  name: "smsList",
  components: {
    cTable
  },
  data() {
    return {
      methods: {
        ...apis
      },
      config: {},
      footer: {},
      modals: {},
      header: {
        searchs: [
          {
            key: 'client_id',
            placeholder() {
              return this.$tz('客户名称');
            },
            component: 'Select',
            options: [],
            optionsFn: 'getAllClient',
            optionsKey: '',
          },
          {
            key: 'phone',
            placeholder() {
              return this.$t('手机号码');
            },
            component: 'Input',
          },
          {
            key: 'keywords',
            placeholder() {
              return this.$t('keyword');
            },
            component: 'Input',
            bind: {
              type: 'textarea',
              autosize: { minRows: 2, maxRows: 2 },
            },
          },
        ],
        btns: {
          list: [
            {
              name: () => this.$tz('导出'),
              type: 'export',
              fnName: 'export',
              bind: {
                type: 'primary',
              },
            },
            {
              name: () => this.$tz('同步'),
              type: 'sync',
              fnName: 'sync',
              bind: {
                type: 'success'
              },
            },
          ],
          methods: {
            sync() {
              this.$Modal.confirm({
                title: this.$tz('同步'),
                width: 300,
                content: this.$t('titleModal'),
                onOk: () => {
                  this.handleRequestMethods('sync', {}, true, true).then(
                    res => {
                      this.getList()
                    }
                  );
                }
              })
            },
            export() {
              this.exportExc();
            }
          }
        }
      },
      fields: [
        {
          type: 'checkbox',
          width: 50,
          align: 'center'
        },

        {
          name: () => this.$t("clientName"),
          key: "clientInfo.client_account",
          minWidth: 130,
        },
        {
          name: () => this.$t("shipper_company_cn"),
          key: "clientInfo.shipper_company_cn",
          minWidth: 130,
        },
        {
          name: () => this.$t("ownership"),
          key: "clientInfo.ownership_name",
          minWidth: 130,
        },
        {
          name: () => this.$t("salesman"),
          key: "clientInfo.salesman_account",
          minWidth: 130,
        },
        {
          name: () => this.$t("phone"),
          key: "phone",
          minWidth: 130,
        },
        {
          name: () => this.$t("smsContent"),
          key: "content",
          minWidth: 200,
        },
        {
          name: () => this.$t("Send Time"),
          key: "send_time",
          minWidth: 150,
        },
        {
          name: () => this.$t("ReceiveTime"),
          key: "receive_time",
          minWidth: 150,
        },
        {
          name: () => this.$t("Send Status"),
          key: "send_status",
          minWidth: 130,
        },
      ]
    }
  }
}
</script>

<style scoped></style>